"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the objects clientRects
 * Used for testing purposes to be able to mock this method
 * @param divElement HTMLDivElement which dimensions are needed
 */
var getClientRects = function (divElement) { return divElement === null || divElement === void 0 ? void 0 : divElement.getClientRects()[0]; };
exports.default = getClientRects;
//# sourceMappingURL=getClientRects.js.map